import axios from "axios";
import toast from "react-hot-toast";
import useAuthStore from "./Zustand/Store/useAuthStore";

/**
 * When backend blocks requests (inactive org user), surface the API message,
 * clear session, and send the user to login. Skips `/api/auth/login` so Login.js
 * can show the same message without double toasts / forced redirect loops.
 */
export function setupAxiosAuthInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url ?? "";
      const msg = error.response?.data?.message;

      const msgLower = typeof msg === "string" ? msg.toLowerCase() : "";
      const isAccessDenied =
        status === 403 &&
        (msgLower.includes("inactive for this organization") ||
          msgLower.includes("not enabled for") ||
          msgLower.includes("not active for your account"));

      if (
        isAccessDenied &&
        !url.includes("/api/auth/login") &&
        !url.includes("/auth/login")
      ) {
        toast.error(msg);
        useAuthStore.getState().logout();
        if (
          typeof window !== "undefined" &&
          !String(window.location.pathname).includes("/login")
        ) {
          window.location.href = "/login";
        }
      }

      return Promise.reject(error);
    }
  );
}
